import { render, staticRenderFns } from "./ColorInfo.vue?vue&type=template&id=02cbea10&"
import script from "./ColorInfo.vue?vue&type=script&lang=js&"
export * from "./ColorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColorInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports